<template>
    <div class="ui segment" style="position: relative;">
        <div class="ui horizontal list">
            <div class="item" v-for="footer_img in $store.state.provider.service_config.footer_imgs">
                <img style="height: 50px;"
                    :src="'/images/'+footer_img"
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Advertising",
}
</script>

<style scoped lang="scss">
</style>
